var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configure-wrapper"},[_c('div',{staticClass:"title"},[_vm._v("配置")]),_c('product-configure'),_c('user-info')],1)}
var staticRenderFns = []

export { render, staticRenderFns }